module.exports = __webpack_public_path__ + "static/media/help.3ceb3f95.svg";